import { OrderedSet } from 'immutable';
export var hasRequiredPropsForRender = function hasRequiredPropsForRender(state) {
  return state.has('error') || state.has('location') || state.get('loading', OrderedSet()).size;
};